// extracted by mini-css-extract-plugin
export default {"root":"NotificationBlock_root__k+VdF","isMobile":"NotificationBlock_isMobile__sgNp8","counter":"NotificationBlock_counter__4kWbq"};